import { useIntl } from 'react-intl';
import { useCallback } from 'react';

import { ErrorNotification } from 'app/components/error-notification/error-notification';
import { Modal } from 'app/components/ui/modal';
import { getErrorDetails } from 'app/shared/utils/get-error-details';
import { ErrorType } from 'app/shared/consts/error-translations';
import { useErrors } from 'app/shared/contexts/errors';

export const ErrorModal = (): JSX.Element | null => {
  const { formatMessage, messages } = useIntl();
  const { errors, hideErrors } = useErrors();
  const handleClose = useCallback(() => {
    hideErrors();
  }, [hideErrors]);

  const { titleTranslationId, descriptionTranslationId, buttonTextTranslationId } = getErrorDetails(
    errors,
    messages,
    ErrorType.ERRORS,
  );

  return (
    <Modal isOpen={errors.length > 0} onClose={handleClose}>
      <ErrorNotification
        title={formatMessage({ id: titleTranslationId })}
        description={formatMessage({ id: descriptionTranslationId })}
        buttonText={formatMessage({ id: buttonTextTranslationId })}
        onClick={handleClose}
      />
    </Modal>
  );
};
